var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrilhas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "#ffffff",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 455 c-27 -39 -34 -42 -43 -20 -9 25 -20 17 -64 -45 -24 -34 -37 -60 -30 -60 7 0 27 20 43 45 33 48 40 53 49 30 9 -23 21 -18 49 21 l25 36 38 -56 c20 -31 41 -56 45 -56 5 0 13 9 19 20 15 28 22 25 56 -20 16 -22 35 -40 42 -40 14 0 -1 23 -53 85 l-25 30 -19 -24 -19 -24 -37 56 c-21 32 -41 57 -45 57 -4 0 -18 -16 -31 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 280 c0 -25 4 -30 25 -30 24 0 25 -2 25 -65 l0 -65 -50 0 c-27 0 -50 -4 -50 -10 0 -23 203 0 229 25 12 11 12 19 1 45 -11 26 -10 33 4 49 10 11 30 22 44 26 15 3 36 8 47 11 11 3 5 -4 -13 -15 -47 -30 -41 -63 13 -74 95 -20 100 -22 103 -45 5 -31 -64 -60 -185 -80 -51 -8 -93 -19 -93 -24 0 -12 36 -10 138 11 113 24 162 51 162 91 0 37 -18 49 -78 57 -105 12 -92 44 29 69 43 10 79 22 79 27 0 5 -40 8 -98 5 -139 -5 -200 -43 -175 -108 11 -29 10 -32 -13 -41 -14 -5 -36 -9 -50 -9 -23 0 -24 3 -24 60 0 59 0 60 29 60 37 0 59 24 41 45 -9 10 -32 15 -76 15 l-64 0 0 -30z m120 0 c0 -5 -22 -10 -50 -10 -27 0 -50 5 -50 10 0 6 23 10 50 10 28 0 50 -4 50 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrilhas);
export default __webpack_public_path__ + "static/media/iconTrilhas.a08742fe1f22f18001a204f96c1eff39.svg";
export { ForwardRef as ReactComponent };